module.exports = __webpack_public_path__ + "img/nav_item_bg2-active.0a2d1eea.png";